module.exports = __webpack_public_path__ + "static/media/corporate-services-img33.3c5f5152.jpg";